<script setup>
import { ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { useGlobalStore } from "@stores/global";

import Button from "@components/global/button.vue";
import Team from "@sections/team.vue";

const breakpoints = ref({
  0: {
    slidesPerView: 2,
  },
  500: {
    slidesPerView: 3,
  },
});

const global = useGlobalStore();
</script>

<template>
  <img
    class="md:right-0 md:block hidden absolute md:top-0 right-[-10%] top-[-20%]"
    src="https://hennep.s3.amazonaws.com/above/images/home/products/planet-half.svg"
    alt=""
  />

  <section class="container mx-auto px-4 py-8 flex flex-col items-center">
    <img
      class="md:right-0 md:hidden block absolute md:top-0 right-[-10%] top-[-50%]"
      src="https://hennep.s3.amazonaws.com/above/images/home/products/planet-half.svg"
      alt=""
    />
    <div class="flex items-center justify-between relative">
      <h1
        class="md:w-half w-[70%] md:max-w-[45%] text-sf-purple-base text-h2 md:text-display-sm font-heading font-medium uppercase break-words"
      >
        Our mission is to lorem ipsum dolor sit amet.
      </h1>
      <img
        class="md:w-[250px] md:block hidden w-[120px] rotate-45 brightness-50 object-cover absolute-y-center right-[20%]"
        src="https://hennep.s3.amazonaws.com/above/images/home/products/planet.png"
        alt=""
      />
      <img
        class="md:block hidden w-[40px] brightness-50 object-cover absolute top-[10%] right-[10%]"
        src="https://hennep.s3.amazonaws.com/above/images/home/products/planet2.png"
        alt=""
      />
    </div>
  </section>

  <section
    class="container overflow-y-hidden w-fit flex md:flex-row flex-col justify-center gap-6"
  >
    <img
      class="w-full md:block hidden absolute-y-center -left-[50%] mix-blend-screen rotate-[22deg] opacity-10"
      src="https://hennep.s3.amazonaws.com/above/images/home/products/aurora.png"
      alt=""
    />
    <img
      class="w-[300px] md:block hidden absolute-y-center left-[5%]"
      src="https://hennep.s3.amazonaws.com/above/images/home/articles/ufo.png"
      alt=""
    />

    <div class="md:max-w-[30%] flex flex-col gap-4 items-start">
      <h2
        class="w-full text-sf-purple-base order-2 md:order-1 text-lg md:text-h4 font-heading font-semibold uppercase leading-tight break-words"
      >
        Incididunt magna incididunt do consequat laborum occaecat dolor ad irure
        consectetur ut consectetur.
      </h2>

      <div
        class="overflow-hidden order-1 md:order-2 sm:self-start h-[70px] w-[300px] -ml-[20px]"
      >
        <Swiper :breakpoints="breakpoints" class="h-full">
          <SwiperSlide
            v-for="social in global.socials"
            :key="social.avatar_url"
            class="flex items-center justify-center"
          >
            <Button
              class="btn-outline small"
              :key="social.avatar_url"
              :href="social.link"
              :title="`${social.platform?.name} - ${social.username}`"
            >
              <i
                :class="social.platform?.icon"
                class="flex items-center justify-center w-4 h-4"
              />
            </Button>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>

    <div class="md:max-w-[30%] flex flex-col md:gap-32 gap-8">
      <p
        class="w-full text-text-muted/50 text-body-md font-body font-medium leading-7 break-words"
      >
        Ad ex consectetur duis consectetur tempor fugiat quis Lorem do non sint
        Lorem non sint. Laboris elit in mollit quis laboris nostrud pariatur
        sunt ea nisi pariatur qui commodo voluptate. Esse ad aliqua labore
        exercitation ea minim nostrud. In aliquip nulla occaecat occaecat.
        Adipisicing aliquip excepteur officia quis nulla adipisicing duis eu.
        Sit elit irure mollit fugiat minim laborum mollit excepteur non. Irure
        eu voluptate anim excepteur minim duis ullamco adipisicing id .
      </p>
      <p
        class="w-full text-text-muted/50 text-body-md font-body font-medium leading-7 break-words"
      >
        Ad ex consectetur duis consectetur tempor fugiat quis Lorem do non sint
        Lorem non sint. Laboris elit in mollit quis laboris nostrud pariatur
        sunt ea nisi pariatur qui commodo voluptate. Esse ad aliqua labore
        exercitation ea minim nostrud. In aliquip nulla occaecat occaecat.
        Adipisicing aliquip excepteur officia quis nulla adipisicing duis eu.
        Sit elit irure mollit fugiat minim laborum mollit excepteur non. Irure
        eu voluptate anim excepteur minim duis ullamco adipisicing id .
      </p>
    </div>
  </section>
  <Team />
</template>
